import { memo, useState } from 'react';
import { roundBook, fmtBook } from '../../utils/casinoBook';

const CDN = 'https://wver.sprintstaticdata.com/v230/static/front/img/cards';

function isSusp(item) {
  return !item || item.gstatus === 'SUSPENDED' || item.gstatus === '0';
}

function suspCls(item) {
  return isSusp(item) ? ' suspended' : '';
}

function fmtAmt(n) {
  const x = Number(n) || 0;
  if (x >= 100000) return `${x / 100000}L`;
  if (x >= 1000) return `${x / 1000}K`;
  return String(x);
}

function bookOf(exposures, name, sid) {
  return roundBook(exposures?.[`sid:${sid}`] ?? exposures?.[name] ?? 0);
}

function bookCls(v) {
  return v < 0 ? 'book-red' : v > 0 ? 'book-green' : 'book-black';
}

// reference: title item me label + info-circle collapse jo min-max range dikhata
// hai. Desktop me ml-1 wrapper ke andar float-right info, mobile me nation-name
// me directly.
function RangeCollapse({ rangeId, min, max, wrap }) {
  const [open, setOpen] = useState(false);
  const info = (
    <>
      <i
        data-toggle="collapse"
        data-target={`#${rangeId}`}
        aria-expanded={open ? 'true' : 'false'}
        className={`fas fa-info-circle float-right${open ? '' : ' collapsed'}`}
        onClick={() => setOpen((o) => !o)}
      ></i>
      {' '}
      <div id={rangeId} className={`collapse icon-range${open ? ' show' : ''}`}>
        {'\n                      R:'}
        <span>{fmtAmt(min ?? 100)}</span>
        -
        <span>{fmtAmt(max ?? 0)}</span>
      </div>
    </>
  );
  return wrap ? <div className="ml-1">{info}</div> : info;
}

const BetTableTeen20 = memo(function BetTableTeen20({ gameData, onBet, exposures }) {
  const sub = gameData?.sub || [];
  const handleBet = onBet || (() => {});

  const byNat = (n) => sub.find((s) => s.nat === n);
  const playerA = byNat('Player A');
  const playerB = byNat('Player B');
  const baccA   = byNat('3 Baccarat A');
  const baccB   = byNat('3 Baccarat B');
  const totalA  = byNat('Total A');
  const totalB  = byNat('Total B');
  const pairA   = byNat('Pair Plus A');
  const pairB   = byNat('Pair Plus B');
  const blackA  = byNat('Black A');
  const blackB  = byNat('Black B');
  const redA    = byNat('Red A');
  const redB    = byNat('Red B');

  // desktop back cell: odds + casino-book book-<clr>
  const backCell = (item, oddOverride) => (
    <div
      className={`back casino-bl-box-item${suspCls(item)}`}
      onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'back', item.b, item)}
    >
      <span className="casino-box-odd">{oddOverride ?? (item?.b ?? 0)}</span>
      {' '}
      <span className={`casino-book ${bookCls(bookOf(exposures, item?.nat, item?.sid))}`}>
        {fmtBook(bookOf(exposures, item?.nat, item?.sid))}
      </span>
    </div>
  );

  // mobile back cell: book-<clr> (no casino-book)
  const mBackCell = (item, oddOverride) => (
    <div
      className={`back casino-bl-box-item${suspCls(item)}`}
      onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'back', item.b, item)}
    >
      <span className="casino-box-odd">{oddOverride ?? (item?.b ?? 0)}</span>
      {' '}
      <span className={bookCls(bookOf(exposures, item?.nat, item?.sid))}>
        {fmtBook(bookOf(exposures, item?.nat, item?.sid))}
      </span>
    </div>
  );

  // desktop suit box (black = spade+club, red = heart+diamond)
  const suitBox = (item, isRed, rangeId, imgTextRight) => (
    <div className={`casino-rb-box ${isRed ? 'redcontainer' : 'blackcontainer'}`}>
      <div
        className={`casino-rb-box-player ${isRed ? 'redbox' : 'blackbox'} back${suspCls(item)}`}
        onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'back', item.b, item)}
      >
        <div className={imgTextRight ? 'text-right' : undefined}>
          {isRed ? (
            <>
              <img src={`${CDN}/heart.png`} />
              {' '}
              <img src={`${CDN}/diamond.png`} className="diamond-icon" />
            </>
          ) : (
            <>
              <img src={`${CDN}/spade.png`} />
              {' '}
              <img src={`${CDN}/club.png`} />
            </>
          )}
        </div>
        <div className="text-right">
          <span className="d-block casino-box-odd">{item?.b ?? 0}</span>
          {' '}
          <span className={`casino-book ${bookCls(bookOf(exposures, item?.nat, item?.sid))}`}>
            {fmtBook(bookOf(exposures, item?.nat, item?.sid))}
          </span>
        </div>
      </div>
      <div className="text-right casino-rb-box-player-range">
        <RangeCollapse rangeId={rangeId} min={item?.min} max={item?.max ?? 25000} />
      </div>
    </div>
  );

  // one desktop side (left = Player A, right = Player B)
  const side = (which, player, bacc, total, pair, black, red, r) => (
    <div className={`teen20${which}`}>
      <div className="casino-box-row">
        <div className="casino-nation-name no-border casino-bl-box-title">
          <div className={which === 'left' ? 'playera' : 'playerb'}>
            {which === 'left' ? 'Player A' : 'Player B'}
          </div>
        </div>
      </div>
      <div className="casino-bl-box casino-bl-box-title">
        <div className="casino-bl-box-item">
          <span>Player</span>
          {' '}
          <RangeCollapse rangeId={r[0]} min={player?.min} max={player?.max ?? 500000} wrap />
        </div>
        <div className="casino-bl-box-item">
          <span>3 Baccarat</span>
          {' '}
          <RangeCollapse rangeId={r[1]} min={bacc?.min} max={bacc?.max ?? 100000} wrap />
        </div>
        <div className="casino-bl-box-item">
          <span>Total</span>
          {' '}
          <RangeCollapse rangeId={r[2]} min={total?.min} max={total?.max ?? 100000} wrap />
        </div>
        <div className="casino-bl-box-item">
          <span>Pair Plus</span>
          {' '}
          <RangeCollapse rangeId={r[3]} min={pair?.min} max={pair?.max ?? 25000} wrap />
        </div>
      </div>
      <div className="casino-bl-box mb-4">
        {backCell(player)}
        {backCell(bacc)}
        {backCell(total)}
        {backCell(pair, which === 'left' ? 'A' : 'B')}
      </div>
      <div className="casino-rb-box-container mb-3">
        {suitBox(black, false, r[4], which === 'left')}
        {suitBox(red, true, r[5], false)}
      </div>
    </div>
  );

  return (
    <>
      {/* ── DESKTOP layout (d-none-small) ── */}
      <div className="teen20casino-container d-none-small">
        {side('left', playerA, baccA, totalA, pairA, blackA, redA, ['range1', 'range2', 'range3', 'range4', 'range5', 'range6'])}
        <div className="teen20center"></div>
        {side('right', playerB, baccB, totalB, pairB, blackB, redB, ['range7', 'range8', 'range9', 'range10', 'range11', 'range12'])}
      </div>

      {/* ── MOBILE layout (d-none-big) ── */}
      <div className="teen20casino-container d-none-big">
        <div className="casino-bl-box casino-bl-box-title">
          <div className="casino-bl-box-item"></div>
          <div className="casino-bl-box-item playera">Player A</div>
          <div className="casino-bl-box-item playerb">Player B</div>
        </div>

        <div className="casino-bl-box">
          <div className="casino-bl-box-item casino-odds-name casino-nation-name">
            <span>Player</span>
            {' '}
            <RangeCollapse rangeId="range1" min={playerA?.min} max={playerA?.max ?? 500000} />
          </div>
          {mBackCell(playerA)}
          {mBackCell(playerB)}
        </div>

        <div className="casino-bl-box">
          <div className="casino-bl-box-item casino-odds-name casino-nation-name">
            <span>3 Baccarat</span>
            {' '}
            <RangeCollapse rangeId="range2" min={baccA?.min} max={baccA?.max ?? 100000} />
          </div>
          {mBackCell(baccA)}
          {mBackCell(baccB)}
        </div>

        <div className="casino-bl-box">
          <div className="casino-bl-box-item casino-odds-name casino-nation-name">
            <span>Total</span>
            {' '}
            <RangeCollapse rangeId="range3" min={totalA?.min} max={totalA?.max ?? 100000} />
          </div>
          {mBackCell(totalA)}
          {mBackCell(totalB)}
        </div>

        <div className="casino-bl-box">
          <div className="casino-bl-box-item casino-odds-name casino-nation-name">
            <span>Pair Plus</span>
            {' '}
            <RangeCollapse rangeId="range4" min={pairA?.min} max={pairA?.max ?? 25000} />
          </div>
          {mBackCell(pairA, 'A')}
          {mBackCell(pairB, 'B')}
        </div>

        <div className="casino-bl-box">
          <div className="casino-bl-box-item casino-odds-name casino-nation-name">
            <div>
              <img src={`${CDN}/spade.png`} />
              {' '}
              <img src={`${CDN}/club.png`} />
            </div>
            {' '}
            <RangeCollapse rangeId="range5" min={blackA?.min} max={blackA?.max ?? 25000} />
          </div>
          {mBackCell(blackA)}
          {mBackCell(blackB)}
        </div>

        <div className="casino-bl-box">
          <div className="casino-bl-box-item casino-odds-name casino-nation-name">
            <div>
              <img src={`${CDN}/heart.png`} />
              {' '}
              <img src={`${CDN}/diamond.png`} />
            </div>
            {' '}
            <RangeCollapse rangeId="range6" min={redA?.min} max={redA?.max ?? 25000} />
          </div>
          {mBackCell(redA)}
          {mBackCell(redB)}
        </div>
      </div>
    </>
  );
});

export default BetTableTeen20;
